<template>
  <el-container>

    <!-- Dialog Header -->
    <el-header height="max-content">
      <el-input 
        v-model="text"
        type="text"
        placeholder="ค้นหาชื่อ หรือ รหัสโครงการ"
        @keypress.enter.native="
          change(text, 1)
        ">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="
            change(text, 1)
          ">
        </el-button>
      </el-input>
      <p class="text-secondary">
        พบข้อมูล {{ total }} โครงการ
      </p>
    </el-header>

    <!-- Dialog Body -->
    <el-main
:style="{
      'max-height': '60vh'
    }">

      <!-- Project Empty -->
      <el-empty
v-if="items.length < 1"
        :image-size="200"
        :description="description"
      />

      <!-- Project List -->
      <div class="list-item">
        <div
          v-for="(item, i) of items" :key="i"
          :class="{
            'active': isActive(item.id),
            'disabled': isDisabled(item.id)
          }"
          class="
            grid-layout item el-card
          "
          @click="
            select(item)
          ">
          <el-avatar
            :size="80"
            shape="square">
            <b>
              {{ item.code }}
            </b>
          </el-avatar>
          <div class="content">
            <b class="text-title">
              {{ item.name }}
            </b>
            <p class="text-secondary text-ellipsis">
              {{ item.location }}
            </p>
          </div>
          <div v-if="!isDisabled(item.id)">
            <el-button
              v-if="
                isActive(item.id)
              "
              type="danger"
              icon="el-icon-delete"
              circle
              @click.stop="
                unselect(item.id)
              "
            />
          </div>
        </div>
      </div>
    </el-main>

    <!-- Dialog Footer -->
    <el-footer height="max-content">
      <el-pagination
        v-if="items.length > 0"
        :current-page.attr="current"
        :page-size="size"
        :total="total"
        class="text-center"
        layout="
          prev, pager, next
        "
        @current-change="
          (page) => change(text, page)
        "
      />
    </el-footer>

  </el-container>
</template>

<script>

// LINE Notify Service
import { useCases } from '../LineNotifyService'

export default {
  name: 'LineNotifySelectProject',
  props: {
    disabledItems: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ''
    },
    page: {
      type: Number,
      default: 1
    },
    selected: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      current: 1,
      items: [],
      size: 10,
      text: '',
      total: 0,
      description: ''
    }
  },
  async created () {
    
    // Init Values
    this.text = this.search
    this.current = this.page
    
    // Fetch Data
    this.change(
      this.search, this.page
    )
  },
  methods: {
    isDisabled (id) {
      return this.disabledItems.some(
        (e) => e === id
      )
    },
    isActive (id) {
      return this.selected.some(
        (e) => e === id
      )
    },
    async change (text, page) {

      // Change Page Event
      this.$emit(
        'page-change', { text, page }
      )

      // Current Page
      this.current = page

      // Fetch Project Data
      await this.fetch()
    },
    select (item) {
      
      // Validate Disabled Items
      const disabled = this.isDisabled(item.id)
      
      // Emit Event
      if (!disabled) this.$emit('select', item)
    },
    unselect (id) {
      this.$emit('unselect', id)
    },
    async fetch () {
      
      // Fetch Project List
      const result = await useCases.projectList(
        this.text, this.current, this.size
      )
      
      // Fetch Result
      const { code, message, items, total } = result

      // Filter Code
      switch (code) {
        case 20000:
          
          // Set Data 
          this.items = items
          this.total = total
          
          break;
        default:
          
          // Reset Data 
          this.items = []
          this.total = 0

          // Error Description
          this.description = message || 'ไม่พบข้อมูล'
          
          break
      }
    }
  },
}
</script>

<style>

@import url('../LineNotify.css');

.item.active .el-avatar {
  background-color: var(--sc-color-dark);
}

.item.disabled,
.item.disabled:hover {
  background-color: #fafafa;
  border-color: #fafafa !important;
}

.item.disabled .el-avatar,
.item.disabled:hover .el-avatar {
  background-color: var(--sc-color-light);
}

.item:hover .el-avatar {
  background-color: var(--sc-color-dark);
}

</style>